import { render, staticRenderFns } from "./FloatingToolbar.vue?vue&type=template&id=1c1a7f9b&scoped=true&lang=pug&"
import script from "./FloatingToolbar.vue?vue&type=script&lang=js&"
export * from "./FloatingToolbar.vue?vue&type=script&lang=js&"
import style0 from "./FloatingToolbar.vue?vue&type=style&index=0&id=1c1a7f9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a7f9b",
  null
  
)

export default component.exports